export const ALCHEMY_API_KEY = 'panJw3SBcFVDQaZdoogSES6dJgr-ngyV'
export const ALCHEMY_URL = `https://eth-mainnet.g.alchemy.com/v2/${ALCHEMY_API_KEY}`;
